export const MATOMO_TRACKER_URL = 'matomo.tracker.url';

export const MATOMO_SITE_ID = 'matomo.request.siteid';

export const MATOMO_ENABLED = 'matomo.enabled';
